import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-one-one-one',
  templateUrl: './two-one-one-one.component.html',
  styleUrls: ['./two-one-one-one.component.scss']
})
export class TwoOneOneOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
